import { EntryMethod } from '../../common/enumerations/entry-method';
import { IItemLookup } from '../../common/interfaces/dtos/IItemLookup';
import { IItemInputData } from '../../common/interfaces/IItemInputData';
import { addLookedupItemToTransaction } from '../../home-page/business-logic/sale-mode-router';

export const sellFoundItem = async (
  itemLookup: IItemLookup,
  quantity: number,
  isManualWeight: boolean,
): Promise<void> => {
  const inputData: IItemInputData = {
    itemId: itemLookup.itemId,
    entryMethod: EntryMethod.Automatic,
    quantity: quantity,
    quantityEntryMethod: quantity > 1 ? EntryMethod.Keyed : EntryMethod.Automatic,
    isManualWeight: isManualWeight,
  };

  await addLookedupItemToTransaction(inputData, itemLookup);
};
